export const CONFIG_KEYS = {
    MIN_DAYS_TO_RESERVE: 'MIN_DAYS_TO_RESERVE',
    MAX_DAYS_TO_RESERVE: 'MAX_DAYS_TO_RESERVE',
    MAX_DATE_BUFFER_MONTHS: 'MAX_DATE_BUFFER_MONTHS',
    MIN_DATE_BUFFER_MONTHS: 'MIN_DATE_BUFFER_MONTHS',
    ADMIN_EMAILS: 'ADMIN_EMAILS',
} as const;
export const datePattern = /^\d{4}-\d{2}-\d{2}$/;
export const mobilePattern = /^(\+\d{1,3}[- ]?)?\d{10}$/;
export const emailPattern = /^\S+@\S+\.\S+$/;